import { motion } from 'framer-motion'
import AnimatedSection from '../common/AnimatedSection'
import LeadershipSectionLabel from '../leadership/LeadershipSectionLabel'
import { leadershipPhilosophy } from '../../data/leadershipPageData'

function LeadershipPhilosophy() {
  const { label, titleLine1, titleAccent, titleLine2, paragraphs, values } = leadershipPhilosophy

  return (
    <AnimatedSection className="leadership-philosophy">
      <div className="leadership-philosophy__bg" aria-hidden="true" />
      <div className="container corp-container">
        <div className="row g-4 g-xl-5 align-items-center">
          <div className="col-lg-6">
            <LeadershipSectionLabel variant="red">{label}</LeadershipSectionLabel>
            <h2 className="leadership-philosophy__title">
              {titleLine1} <span>{titleAccent}</span> {titleLine2}
            </h2>
            {paragraphs.map((paragraph) => (
              <p className="leadership-philosophy__text" key={paragraph.slice(0, 24)}>
                {paragraph}
              </p>
            ))}
          </div>

          <div className="col-lg-6">
            <ul className="leadership-philosophy__values" role="list">
              {values.map((item, index) => {
                const Icon = item.icon
                return (
                  <motion.li
                    key={item.title}
                    role="listitem"
                    initial={{ opacity: 0, x: 24 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.45, delay: index * 0.08 }}
                  >
                    <span className="leadership-philosophy__value-icon" aria-hidden="true">
                      <Icon />
                    </span>
                    <span>{item.title}</span>
                  </motion.li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </AnimatedSection>
  )
}

export default LeadershipPhilosophy
